/** Canonical GenuFit support contact for user-facing UI copy. */
export const SUPPORT_EMAIL = 'support@genufit.app'

export function supportMailtoHref(subject?: string): string {
  if (!subject) return `mailto:${SUPPORT_EMAIL}`
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`
}
